<template>
    <section class="c-login">
        <div class="c-login__body">

            <app-intro class="u-d-flex justify-content-center">
                <h1>Inloggen</h1>
            </app-intro>

            <login-form />

        </div>
    </section>
</template>

<script>
    import AppIntro from '../../components/app/AppIntro.vue';
    import LoginForm from '../../components/forms/LoginForm.vue';

    export default {
        components: { LoginForm, AppIntro },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-login {
        display: grid;
        height: 100%;

        &__body {
            align-self: center;
            justify-self: center;
            padding: 0 grid(1);

            @include media-breakpoint-up(md) {
                margin: 0 auto;
                padding: 0;
                width: grid(12, lg);
            }
        }
    }
</style>
